"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _TransferHistoryComponent = _interopRequireDefault(require("./TransferHistoryComponent"));
var _transferSelectors = require("../../../redux/selectors/transferSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var fetching = state.transfer.fetching;
  var transfers = (0, _transferSelectors.transferReceiverUserNames)(state);
  return {
    transfers: transfers,
    fetching: fetching
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_TransferHistoryComponent["default"]);